import React, { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { usePrice } from "../../../../hooks/usePrice";
import { fetch } from "../../../../API";
import { createCategorySlug, createProductSlug } from "../../../../utils/urlUtils";

import {
    SearchResultsStyled,
    ShowMoreStyled,
} from "./SearchForm.styled";

const IMAGE_API_URL =
    `${process.env.REACT_APP_API_BASE_URL}/public/images/`;

export const SearchForm = ({ query, onChange, onNavigate }) => {
    const [cats, setCats] = useState([]);
    const [prods, setProds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { countSalePrice } = usePrice();

    const debounced = useDebouncedCallback((q) => {
        if (q.trim().length < 2) {
            setCats([]);
            setProds([]);
            return;
        }
        (async () => {
            setLoading(true);
            try {
                const resp = await fetch(`search?query=${encodeURIComponent(q)}`);
                setCats(resp.data.matchedCatalogs || []);
                setProds(resp.data.matchedProducts || []);
            } catch (err) {
                console.error(err);
                setError(err);
            } finally {
                setLoading(false);
            }
        })();
    }, 300);

    useEffect(() => {
        debounced(query);
    }, [query, debounced]);

    return (
        <SearchResultsStyled>
            <div className="left">
                {cats.length > 0 && (
                    <>
                        <h4>Ищите по каталогам</h4>
                        <ul>
                            {cats.map((c) => (
                                <li key={c.id}>
                                    <button onClick={() => onNavigate(`/shop?category=${c.id}`)}>
                                        {c.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>

            <div className="right">
                {prods.length > 0 && (
                    <>
                        <h4>Популярные товары</h4>
                        <ul>
                            {prods.map((p) => {
                                const displayNameEN =
                                    (p.nameInEnglish || p.name || "").trim();

                                // ищем категорию; если нет — fallback первая
                                const category =
                                    cats.find((cat) => cat.id === p.categoryId) || cats[0];

                                const categoryNameEN =
                                    (category?.nameInEnglish || category?.name || "").trim();

                                const categorySlug = createCategorySlug(categoryNameEN);
                                const productSlug = createProductSlug(displayNameEN);

                                return (
                                    <li key={p.id} className="product-item">
                                        <img
                                            src={`${IMAGE_API_URL}${encodeURIComponent(p.imageUrl)}`}
                                            alt={displayNameEN}
                                            width={64}
                                            height={64}
                                        />
                                        <div className="product-info">
                                            <button
                                                onClick={() =>
                                                    onNavigate(
                                                        `/shop/${categorySlug}/${productSlug}?id=${p.id}`
                                                    )
                                                }
                                            >
                                                {displayNameEN}
                                            </button>

                                            {p.price && (
                                                <p className="product-price">{p.price} ₸</p>
                                            )}
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>

                        <ShowMoreStyled
                            onClick={() =>
                                onNavigate(`/shop?q=${encodeURIComponent(query)}`)
                            }
                        >
                            Все по запросу ({prods.length})
                        </ShowMoreStyled>
                    </>
                )}
            </div>

            {loading && <div className="loader">Загрузка…</div>}
            {error && <div className="error">{error.message}</div>}
        </SearchResultsStyled>
    );
};
